import { Component, Input, ViewChild } from '@angular/core';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { Editor } from 'primeng/editor';
import { EditorTextChangeEvent } from 'primeng/types/editor';

@Component({
  selector: 'eg-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrl: './text-editor.component.scss',
  providers: [...ValueAccessorUtil.getValueAccessorProvider(TextEditorComponent)],
  standalone: false,
})
export class TextEditorComponent extends AbstractValueAccessorComponent<string> {
  @Input() prefixInputPadding = 10;
  @Input() modules: object | undefined;
  prefixContainerWidth?: number;

  @ViewChild('editor', { static: true }) editor: Editor;

  onTextChange(event: EditorTextChangeEvent) {
    this.value = event?.htmlValue;
    this.onChange(this.value);
    this.formControl?.setValue(this.value);
    this.changed.emit(this.value);
  }

  onInitEditor() {
    if (this.editor) {
      const quill = this.editor.getQuill();
      quill.root.innerHTML = this.value;
    }
  }
}
